import React, { useState } from "react";
import {
  IonContent,
  IonPage,
  IonSpinner,
  useIonViewWillEnter,
} from "@ionic/react";
import { client } from "../../api/client";
import "./AdminHelpRequests.css";
import { Link } from "react-router-dom";

const AdminHelpRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("open");

  useIonViewWillEnter(() => {
    fetchRequests();
  });
  const deleteRequest = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete this request?")) {
        return;
      }
      await client.delete(`/report/delete-request/${id}`);
      setRequests((prev) => prev.filter((req) => req._id !== id));
    } catch (error) {
      console.error("Error deleting request:", error);
    }
  };
  const fetchRequests = async () => {
    try {
      setLoading(true);
      const res = await client.get("/report/requests");
      setRequests(res.data);
    } catch (error) {
      console.error("Error loading reports:", error);
    } finally {
      setLoading(false);
    }
  };
  const markRequestAsResolved = async (id) => {
    try {
      await client.put(`/report/mark-request-resolved/${id}`);
      setRequests((prev) =>
        prev.map((req) =>
          req._id === id ? { ...req, status: "closed" } : req,
        ),
      );
    } catch (error) {
      console.error("Error marking request as resolved:", error);
    }
  };

  const filteredRequests = requests.filter((req) =>
    activeTab === "open" ? req.status === "open" : req.status === "closed",
  );

  return (
    <IonPage>
      {/* Ensure Ionic background matches the design */}
      <IonContent fullscreen style={{ "--background": "#f4f5f8" }}>
        {/* SCOPED WRAPPER CLASS */}
        <div className="admin-requests-page">
          <div className="admin-header">
            <h1 className="logo">Requests</h1>
            <div className="tab-group">
              <button
                className={`tab-btn ${activeTab === "open" ? "active" : ""}`}
                onClick={() => setActiveTab("open")}
              >
                Pending
              </button>
              <button
                className={`tab-btn ${activeTab === "closed" ? "active" : ""}`}
                onClick={() => setActiveTab("closed")}
              >
                Resolved
              </button>
            </div>
          </div>

          {loading ? (
            <div className="loading-state">
              <IonSpinner name="crescent" />
            </div>
          ) : (
            <div className="request-list">
              {filteredRequests.length === 0 ? (
                <div className="empty-state">
                  No {activeTab} requests found.
                </div>
              ) : (
                filteredRequests.map((req) => (
                  <div key={req._id} className="request-card">
                    <div className="card-section">
                      <span className="section-title">REQUESTED BY:</span>
                      <Link
                        className="user-row"
                        to={`/profile/${req.requester?.username || ""}`}
                      >
                        <img
                          src={req.requester?.avatarUrl || "/logo4.png"}
                          alt="avatar"
                          className="user-avatar"
                        />
                        <span className="user-name">
                          {req.requester?.username || "Unknown User"}
                        </span>
                      </Link>
                    </div>

                    <div className="card-section">
                      <span className="section-title">CATEGORY:</span>
                      <span className="category-text">{req.category}</span>

                      <span className="section-title">SUBJECT:</span>
                      <h3 className="subject-text">{req.title}</h3>

                      <span className="section-title">DESCRIPTION:</span>
                      <div className="description-box">{req.description}</div>
                    </div>

                    <div className="action-row">
                      {req.status === "open" && (
                        <button
                          className="btn-resolve"
                          onClick={() => markRequestAsResolved(req._id)}
                        >
                          Mark as Resolved
                        </button>
                      )}
                      <button
                        className="btn-delete"
                        onClick={() => deleteRequest(req._id)}
                      >
                        Delete
                      </button>
                    </div>

                    <div className="timestamp">
                      {new Date(req.createdAt).toLocaleString()}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default AdminHelpRequests;
